import {ApiRequest, ApiResponse} from "@gongt/ts-stl-library/request/protocol";
import {ERequestType} from "@gongt/ts-stl-library/request/request";

export const UpdateProfileUrl = `/do_update_profile`;
export const UpdateProfileMethod = ERequestType.TYPE_POST;

export interface UpdateProfileBody extends ApiRequest {
	token: string;
	newProfile: object;
}

export interface UpdateProfileResponse extends ApiResponse {
}
